import { MarketingCompanySize } from 'lib/types/company';

interface IChiliPiperPayload {
  firstName: string;
  lastName: string;
  email: string;
  companySize: MarketingCompanySize;
  interest: string;
  billingMethod: string;
}

interface IChiliPiperResponse {
  url?: string;
  error?: boolean;
}

export const getChiliPiperBookingUrl = async (
  payload: IChiliPiperPayload
): Promise<IChiliPiperResponse> => {
  const response = await fetch(
    'https://api.chilipiper.com/marketing/goethena',
    {
      method: 'POST',
      body: JSON.stringify({
        form: {
          firstname: payload.firstName,
          lastname: payload.lastName,
          email: payload.email,
          companySize__c: payload.companySize,
          in_app_sales_request__c: payload.interest,
          in_app_sales_request_type__c: payload.billingMethod,
        },
        options: {
          router: 'in-app-router',
          debug: false,
          map: false,
        },
      }),
      headers: {
        'Content-Type': 'application/json',
      },
    }
  );
  if (response.status >= 200 && response.status < 300) {
    return await response.json();
  } else {
    throw new Error('Error fetching ChiliPiper booking URL');
  }
};
